module.exports = __webpack_public_path__ + "img/sbtn3.a02fe372.png";